export default class NumberHelper {
  static EPSILON = 1e-9;

  static round(number: number, precision: number = 2) {
    return this.roundWithFunction(number, "round", precision);
  }

  static roundWithFunction(
    number: number,
    roundFunction: "ceil" | "floor" | "round" | null = "round",
    precision: number = 2,
  ): number {
    const coefficient = Math.pow(10, precision);

    if (roundFunction === "round") {
      return Math.round(number * coefficient) / coefficient;
    }

    if (roundFunction === "ceil") {
      return Math.ceil(number * coefficient) / coefficient;
    }

    if (roundFunction === "floor") {
      return Math.floor(number * coefficient) / coefficient;
    }

    return number;
  }

  static discountCoefficient(percentDiscount: number): number {
    return (100 - percentDiscount) / 100;
  }

  static vatCoefficient(vatRate: number): number {
    return (100 + vatRate) / 100;
  }

  static priceIncludingVat(
    price: number,
    vatRate: number,
    includingVat: boolean,
  ) {
    if (includingVat) {
      return price;
    }

    return price * NumberHelper.vatCoefficient(vatRate);
  }

  static priceWithOutVat(
    price: number,
    vatRate: number,
    includingVat: boolean,
  ) {
    if (!includingVat) {
      return price;
    }

    return price * (1 - vatRate / (100 + vatRate));
  }

  static discountWithVat(
    price: number,
    vatRate: number,
    discountAmount: number,
  ): { discount: number; discountWoVat: number; remainingDiscount: number } {
    const amount = Math.min(discountAmount, price);
    const discountPriceWoVat = NumberHelper.priceWithOutVat(
      amount,
      vatRate,
      true,
    );
    const discountPriceIncVat = NumberHelper.priceIncludingVat(
      discountPriceWoVat,
      vatRate,
      false,
    );
    return {
      discount: discountPriceIncVat,
      discountWoVat: discountPriceWoVat,
      remainingDiscount: discountAmount - amount,
    };
  }

  static discountWithoutVat(
    price: number,
    vatRate: number,
    discountAmount: number,
  ): { discount: number; discountWoVat: number; remainingDiscount: number } {
    const priceWoVat = NumberHelper.priceWithOutVat(price, vatRate, true);
    const amount = Math.min(discountAmount, priceWoVat);
    const discountPriceWoVat = NumberHelper.priceWithOutVat(
      amount,
      vatRate,
      false,
    );
    const discountPriceIncVat = NumberHelper.priceIncludingVat(
      discountPriceWoVat,
      vatRate,
      false,
    );
    return {
      discount: discountPriceIncVat,
      discountWoVat: discountPriceWoVat,
      remainingDiscount: discountAmount - amount,
    };
  }
}
